export enum BlindType {
  TYPE_ANTE = 'TYPE_ANTE',
  TYPE_SB = 'TYPE_SB',
  TYPE_BB = 'TYPE_BB',
  TYPE_STRADDLE = 'TYPE_STRADDLE',
  TYPE_SBB = 'TYPE_SBB',
  TYPE_BLIND_SB_TO_MID = 'TYPE_BLIND_SB_TO_MID',
  TYPE_BLIND_BB_TO_MID = 'TYPE_BLIND_BB_TO_MID',
  TYPE_BB_IN_FRONT = 'TYPE_BB_IN_FRONT',
}
